export const getTransportationModeDescription = (code, transportationModes = []) => {
  const value = transportationModes.find((value) => value.lookupCodeId === code);
  return value?.displayValue || code;
};

export const getTransportationModeSelectOptions = (transportationModes = []) => {
  return transportationModes?.map((row) => ({
    label: row.displayValue,
    value: row.lookupCodeId,
  }));
};
